import React from 'react'
import About from '../../pages/about'
import Category from './Features/category'
import FoodGrid from './Features/featuredfood'
import Contact from '../../pages/contact'
import BakeryFooter from '../footer'
import Navbar from '../nav'
import Menu from './Features/menu'
import Heropage from './Features/Heropage'
import Cakedisplay from './Features/Cakedisplay'
import Abouthome from './Features/Abouthome'
import Frontpage from './Features/Frontpage'
import ContactComp from './Features/ContactComp'
import Specialproduct from './Features/Specialproduct'
import Testimonials from './Features/Testimonials'

export default function Homecomponent() {

  return (

    <>
    <Navbar />
<div className="top-10">
  {/* <Frontpage /> */}
  <Heropage />
  <Abouthome />
  <Specialproduct />
  <Category />

  <hr className='mb-4 mt-4' />
  <Cakedisplay />
  
  {/* <FlashSales /> */}
  {/* <Menu /> */}

  {/* <FoodGrid /> */}
  <ContactComp />
  <Testimonials />
  <BakeryFooter />
</div>  
    </>
    

)
}

   
